import React from "react";
import Selina from "../../img/selina.png"
import Marcus from "../../img/marcus.png"
import Avery from "../../img/avery.png"

const teamMembers = [
  {
    name: "Selina Duvall",
    title: "Chief Blockchain Strategist",
    description:"Oversees blockchain integration, scalability, and long-term tech vision.",
    image:`${Selina}` , // Replace with actual path or URL
  },
  {
    name: "Marcus Varela",
    title: "Crypto Risk & Compliance Lead",
    description:"Manages regulatory compliance, KYC/AML policies, and market risk assessments.",
    image: `${Marcus}`,
  },
  {
    name: "Avery Stanwell",
    title: "Head of Algorithmic Trading",
    description:"Designs and optimizes automated trading systems and data-driven strategies.",
    image: `${Avery}`,
  },
];

const TeamSection = () => {
  return (
    <div className="bg-[radial-gradient(93.96%_223.34%_at_-10.76%_33.62%,_#07031C_0%,_#241D49_30.52%,_#07031C_64.32%)] text-white md:py-20 py-28 px-6 md:px-24 text-center">
      <h2 className="text-3xl md:text-[28px] font-semibold mb-12 font-lato text-left">
        Meet The <span className="text-[#F2C493]">Team</span> <br className="md:hidden"/> That Makes It<br/> Happen
      </h2>

      <div className="grid md:grid-cols-3 gap-12 ">
        {teamMembers.map((member, idx) => (
          <div key={idx} className="flex flex-col items-start">
            <img
              src={member.image}
              alt={member.name}
              className="rounded-xl md:w-60 w-full md:h-72 h-96 object-cover mb-4 shadow-lg"
            />
            <div className="text-white font-semibold text-lg">{member.name}</div>
            <div className="text-[#F2C493] font-medium mb-2">-{member.title}</div>
            <div className="w-full md:w-[300px] text-left">
              <p className="text-sm text-white">{member.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamSection;
